import { SYSTEM } from 'containers/Ezlo/EzloMeshbots/constants';
import { FEATURE_FLAGS } from 'constants/common/feature_flags';

/**
 * Determines if a meshbot can be edited based on its type and feature flags
 *
 * @param {Object} item - The meshbot item to check
 * @param {Object} [item.generator] - Generator information for the meshbot
 * @param {string} [item.generator.role] - Role of the meshbot generator (e.g., 'system', 'user')
 * @returns {boolean} Returns true if the meshbot can be edited, false otherwise
 *
 * @description
 * - System TCDS meshbots: Editable only if TCDS_SYSTEM_MESHBOT_EDITING feature flag is enabled
 * - All other meshbots: Always editable (returns true)
 *
 * @example
 * // System meshbot with feature flag disabled
 * const systemMeshbot = { generator: { role: 'system' } };
 * canEditMeshBot(systemMeshbot); // false (if feature flag is disabled)
 *
 * @example
 * // User meshbot
 * const userMeshbot = { generator: { role: 'user' } };
 * canEditMeshBot(userMeshbot); // true
 *
 * @example
 * // Meshbot without generator
 * canEditMeshBot({}); // true
 */
export const canEditMeshBot = (item) => {
    if (item?.generator?.role === SYSTEM) {
        return FEATURE_FLAGS.TCDS_SYSTEM_MESHBOT_EDITING.enabled;
    }

    return true;
};
